import React from "react";

export default function LandingPriceLine({
  status,
  line,
  className,
  showEmptyCopy = false,
}) {
  if (status === "loading") return null;
  if (!line) {
    if (!showEmptyCopy) return null;
    return <p className={className}>Pricing available after you start a trial</p>;
  }
  return (
    <p className={className} data-testid="landing-catalog-price">
      {line}
    </p>
  );
}
